import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransformationProtocol } from '../../models/transformationProtocol';

@Component({ standalone:false,
  selector: 'app-select-transformation-protocol-dialog',
  templateUrl: 'select-transformation-protocol-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['select-transformation-protocol-dialog.component.scss']
})
export class SelectTransformationProtocolComponent {
  title: string= "Select the field to add a transformation override";
  message: string = "Caution: By selecting the field below, you will be changing the default transformation behavior.";
  confirmButtonText = "Add Override";
  cancelButtonText = "Cancel";
  transformationProtocols!: TransformationProtocol[];
  selectedTransformationProtocol?: TransformationProtocol;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<SelectTransformationProtocolComponent>) {
    if(data){
        this.title=data.title || this.title;
        this.message = data.message || this.message;
        this.transformationProtocols = data.transformationProtocols;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
  }

  get canClickConfirm(): boolean{
    return this.selectedTransformationProtocol!=undefined;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedTransformationProtocol);
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}